import { createAnalytics } from '@omnicanvas/analytics'

export const { track } = createAnalytics('marketing')
